'use client';

import { format, getHours, getMinutes } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useEffect, useState } from 'react';

import { useGetContent } from '@/lib/react-query/ContentQueries';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
};

const OpenIndicator = ({ className = '' }: Props) => {
  const [isShopOpen, setIsShopOpen] = useState(false);
  const { data: content, error, isLoading } = useGetContent();
  const horaires = content?.horaire;

  useEffect(() => {
    const checkShopStatus = () => {
      if (!horaires) return;

      const now = new Date();
      const currentDay = format(now, 'eeee', { locale: fr });
      const currentTime = getHours(now) * 100 + getMinutes(now);

      const todayHours = horaires.find((h) => h.day.toLowerCase() === currentDay.toLowerCase());

      if (!todayHours?.is_open || !todayHours.horaires) {
        setIsShopOpen(false);
        return;
      }

      const [open, close] = todayHours.horaires.split(' - ').map((time) => {
        const [hour, minute] = time.split(':');
        return parseInt(hour || '') * 100 + parseInt(minute || '');
      });

      setIsShopOpen(currentTime >= open && currentTime <= close);
    };

    // Initial check
    checkShopStatus();

    // Set interval to check every minute
    const interval = setInterval(checkShopStatus, 60000);

    return () => clearInterval(interval);
  }, [horaires]);

  if (isLoading || !horaires || error) {
    return null;
  }

  return (
    <div className={cn(className)}>
      {isShopOpen ? (
        <div className="inline-flex items-center gap-2 rounded bg-emerald-200/40 p-2 text-xs text-emerald-800">
          <span className="h-3 w-3 rounded-full bg-emerald-700" /> Le shop est ouvert
        </div>
      ) : (
        <div className="inline-flex items-center gap-2 rounded bg-red-200/40 p-2 text-xs text-red-800">
          <span className="h-3 w-3 rounded-full bg-red-700" /> Le shop est fermé
        </div>
      )}
    </div>
  );
};

export default OpenIndicator;
